const ChaptersTypes = {
  SET_CHAPTERS_LOADING: 'CHAPTERS/SET_CHAPTERS_LOADING',
  SET_CHAPTERS_FAILURE: 'CHAPTERS/SET_CHAPTERS_FAILURE',
  SET_CHAPTERS_SUCCESS: 'CHAPTERS/SET_CHAPTERS_SUCCESS',
};

export default ChaptersTypes;